import { render, staticRenderFns } from "./update-document-modal.vue?vue&type=template&id=8ba5fa6e"
import script from "./update-document-modal.vue?vue&type=script&lang=js"
export * from "./update-document-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports